import React, { useState, useEffect, useContext } from 'react';
import { Table, Button } from 'react-bootstrap';
import { UserContext } from '../contexts/UserContext';
import { getAllTenants } from '../services/tenantsService';
import { utcISOToNZTimezoneDateFormat } from '../utils/format';
import { showDefaultAlert } from '../utils/alerts';
import SpinnerA from '../components/Spinner';
import TenantModel from '../components/TenantModel';
import ReactPaginate from 'react-paginate';
import '../App.css';
import '../assets/css/Tenants.css';

export const Tenants = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [addedTenant, setAddedTenant] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const { token } = useContext(UserContext);

  const itemsPerPage = 10;
  const offset = currentPage * itemsPerPage;
  const currentPageItems = tenants?.slice(offset, offset + itemsPerPage);

  useEffect(() => {
    const setNewTenant = (addedTenant) => {
      if (addedTenant && Object.keys(addedTenant).length > 0) {
        setTenants((prev) => [...prev, addedTenant]);
      }
    };
    setNewTenant(addedTenant);
  }, [addedTenant]);

  useEffect(() => {
    const fetchTenants = async () => {
      setLoading(true);
      try {
        const response = await getAllTenants(token);
        setTenants(response.data || []);
      } catch (error) {
        showDefaultAlert('error', 'Error', 'An error occurred. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchTenants();
  }, [token]);

  const handleAddTenantModel = () => {
    setShowModel(true);
  };

  return (
    <div className="tenants-page">
      <div className="tenants-shell">
        <div className="tenants-header">
          <div>
            <h2 className="tenants-header__title">Tenant Management</h2>
          </div>
          <Button className="btn btn-danger tenants-btn" onClick={handleAddTenantModel}>Add Tenant</Button>
        </div>
        {loading ? (<SpinnerA />) : (
          <div className="tenants-card">
            <div className="tenants-table-wrapper">
              <Table responsive="sm" hover className="tenants-table">
                <thead>
                  <tr>
                    <th>Tenant Name</th>
                    <th>Status</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {tenants.length === 0 ? (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center" }}>
                        <h5>No records found.</h5>
                      </td>
                    </tr>
                  ) : (
                    <React.Fragment>
                      {currentPageItems.map((tenant, index) => (
                        <tr key={tenant.tenantID || index}>
                          <td>{tenant.tenantName}</td>
                          <td>
                            <span className={`tenants-status ${tenant.status === 'active' ? 'is-active' : 'is-inactive'}`}>
                              {tenant.status}
                            </span>
                          </td>
                          <td>{utcISOToNZTimezoneDateFormat(tenant.createdAt)}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  )}
                </tbody>
              </Table>
            </div>
            {tenants.length > itemsPerPage && (
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={Math.ceil(tenants.length / itemsPerPage)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(data) => setCurrentPage(data.selected)}
                containerClassName={'pagination'}
                activeClassName={'active'}
                previousClassName={'pagination-previous'}
                nextClassName={'pagination-next'}
                pageClassName={'pagination-page'}
                breakClassName={'pagination-break'}
                previousLinkClassName={'pagination-previous-link'}
                nextLinkClassName={'pagination-next-link'}
                disabledClassName={'pagination-disabled'}
              />
            )}
          </div>
        )}
      </div>
      {showModel && <TenantModel closeModel={setShowModel} setAddedTenant={setAddedTenant} />}
    </div>
  );
};
